import { useRetrievePermission } from '../../../hooks/useRetrievePermission';
import { Button, Chip, Drawer, Stack } from '@mui/material';
import { filter, get } from 'lodash';
import { useCallback } from 'react'
import {  ChipField, Datagrid, DateField, FilterButton, FunctionField, List, RaRecord, TextField, TopToolbar } from 'react-admin';
import ReactJson from 'react-json-view';
import { Link, matchPath, useLocation, useNavigate } from 'react-router-dom';
import EditIcon from "@mui/icons-material/Edit";
import { CreateServiceRewards } from './CreatePage';
import { EditServiceReward } from './EditPage';
import { RewardFilters } from './components/ListPageFilter';
import { ContentCopy } from '@mui/icons-material';

const baseUrl = '/services/rewards';

const ListActions = ({filters}: any) => {
    const [isSuperAdmin, isAdmin] = useRetrievePermission();

    return (
        <TopToolbar>
            <FilterButton filters={filters} />
            {(isSuperAdmin || isAdmin) && <Button
                color="primary"
                size="small"
                data-testid="create_button"
                component={Link}
                to={{
                    pathname: `${baseUrl}/create`,
                }}
            >
                + Add New
            </Button>}
        </TopToolbar>
    )
}

export const RewardsList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isSuperAdmin, isAdmin] = useRetrievePermission();

    const matchCreate = matchPath(
        `${baseUrl}/create`,
        location.pathname
    );

    let matchEdit = null;
    if (!location.pathname.endsWith("create")){
        matchEdit = matchPath(`${baseUrl}/:id`, location.pathname);
    }

    const onCloseDrawer = useCallback(() => {
        navigate(baseUrl)
    }, [navigate]);

  return (
    <>
        <List
            resource='rewardCatalogues'
            sort={{ field: "created_at", order: "DESC" }}
            empty={false}
            title="Service &rsaquo; Reward"
            filters={RewardFilters}
            actions={<ListActions filters={RewardFilters} />}
        >
            <Datagrid
                bulkActionButtons={false}
            >
                <DateField
                    source="created_at"
                    label="Created"
                    showTime
                    locales="en-HK"
                    options={{
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                    }}
                />
                <ChipField source='delivery_mode' />
                <FunctionField 
                    label="Availability By Services" 
                    render={(record: any) => {
                        const services = get(record, 'availability_by_service', [])
                        return services.map((service: string) => <Chip 
                            style={{ margin: "0px 5px 5px 5px" }}
                            size="small" 
                            label={service} 
                            key={service} 
                        />)
                    }} 
                />
                <TextField source='item_detail.item.category' label="Category" sortable={false} />
                <FunctionField label="Codes" render={(record?: RaRecord) => {
                    const rewardCodes = (get(record || {}, 'reward_codes', []) || []) as Array<{ status?: string }>; 
                    const norm = (s?: string) => (s || '').toUpperCase();
                    const availableCount = filter(rewardCodes, rc => norm(rc.status) === 'AVAILABLE').length;
                    const redeemedCount = filter(rewardCodes, rc => norm(rc.status) === 'REDEEMED').length;
                    const awaitingCount = filter(rewardCodes, rc => norm(rc.status) === 'AWAITING_PICK_UP').length;
                    return (
                        <Stack direction="row" spacing={1}>
                            <Chip size="small" color="success" label={(<>available: <b>{availableCount}</b></>)} />
                            <Chip size="small" color="info" label={(<>redeemed: <b>{redeemedCount}</b></>)} />
                            <Chip size="small" color="warning" label={(<>awaiting pick up: <b>{awaitingCount}</b></>)} />
                        </Stack>
                    );
                }}/>
                <FunctionField
                    label="Item Label"
                    onClick={(e: any) => e.stopPropagation()}
                    render={(record?: RaRecord) => (
                    <div>
                        <label>
                            <ReactJson
                                src={record?.item_label || {}}
                                collapsed={false}
                                name={false}
                                enableClipboard={false}
                                displayDataTypes={false}
                                displayObjectSize={false}
                            />
                        </label>
                    </div>
                    )}
                />
                                {(isSuperAdmin || isAdmin) && <FunctionField
                                        render={(record?: RaRecord) => {
                        return (
                          <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
                            <Button
                                color="primary"
                                size="small"
                                data-testid="edit_button"
                                component={Link}
                                to={{
                                                                        pathname: `${baseUrl}/${record?.id}`,
                                }}
                            >
                                <EditIcon fontSize='small' /> Edit
                            </Button>
                            <Button
                              color="primary"
                              size="small"
                              data-testid="copy_button"
                              onClick={() => {
                                                                if (record?.id) {
                                                                    window.navigator.clipboard.writeText(record.id as string);
                                                                    alert(`Reward ID ${record.id} copied to clipboard`);
                                                                }
                              }}
                            >
                              <ContentCopy fontSize="small" /> Copy ID
                            </Button>
                          </Stack>
                        );
                    }}
                    source="content"
                    label="Action"
                    sortable={false}
                />}
            </Datagrid>
        </List>
        <Drawer
            variant="persistent"
            open={!!matchCreate || !!matchEdit}
            anchor="right"
            onClose={onCloseDrawer}
        >
            {!!matchCreate && <CreateServiceRewards onClose={onCloseDrawer}/>}
            {!!matchEdit && <EditServiceReward
                id={(matchEdit as any).params.id} 
                onClose={onCloseDrawer} />}
        </Drawer>
    </>
  )
}
